import { useRouter } from 'next/router';
import { useApiData } from 'lib/api';
import { LoadingIndicator } from 'components/common';
import {
  ConversationAnalysisBusinessInsights,
  ConversationAnalysisInfo,
  ConversationAnalysisQuestions,
  ConversationAnalysisStats,
  ConversationAnalysisSummary,
  ConversationAnalysisTrends
} from '.';

import type { GetAchievementDiscussionAnalysisRes } from 'shared-types/responses';

const ConversationAnalysis = () => {
  const router = useRouter();

  const { data, loading } = useApiData<GetAchievementDiscussionAnalysisRes>({
    url: `/admin/achievements/discussion-analysis/${router.query.analysisId}`
  });

  return (
    <div className="wrapper">
      {loading ? (
        <LoadingIndicator />
      ) : data?.analysis ? (
        <div className="analysis">
          <ConversationAnalysisInfo data={data} />

          <ConversationAnalysisStats
            metadata={data.metadata}
            numberOfKeyFindings={
              data.analysis?.executiveSummary?.keyFindings?.length || 0
            }
          />

          <ConversationAnalysisSummary
            summary={data.analysis.executiveSummary}
          />

          <ConversationAnalysisBusinessInsights
            insights={data.analysis.businessInsights}
          />

          <ConversationAnalysisQuestions
            numberOfAnswersByQuestionId={data.numberOfAnswersByQuestionId}
            questions={data.analysis.questions}
            sentimentAnalysisPerQuestion={
              data.analysis.sentimentAnalysisPerQuestion
            }
          />

          <ConversationAnalysisTrends
            trendAnalysis={data.analysis.trendAnalysis}
          />
        </div>
      ) : (
        <ConversationAnalysisInfo data={null} />
      )}

      <style jsx>{`
        .analysis {
          display: flex;
          flex-direction: column;
          gap: 30px;
        }
      `}</style>
    </div>
  );
};

export default ConversationAnalysis;
